import { findCheapestProductArrays, getEntityProductData, getProductRefFromProduct, getColorOfProduct, getMajorityColorOfProducts, getMountingRailsProducts, } from "./getProductData";
import { getSmallestArrays } from "./index";
import { LENGTH_TYPE_CODE } from "../constants";
import { NO_MOUNTING_RAIL_LENGTH } from "../constants/errors";
import { getBoaxelSolutions, getUprightsInSolution, getWidthOfSolution, } from "./getEntityData";
const getLengthOfMountingRail = (mountingRail) => {
    var _a, _b, _c;
    const railLength = (_c = (_b = (_a = mountingRail.content) === null || _a === void 0 ? void 0 : _a.measure) === null || _b === void 0 ? void 0 : _b.find((productMeasure) => productMeasure.typeCode === LENGTH_TYPE_CODE)) === null || _c === void 0 ? void 0 : _c.value;
    if (!railLength)
        throw new Error(NO_MOUNTING_RAIL_LENGTH);
    return railLength;
};
const findArraysOfMountingRailsCoveringLength = (mountingRailProducts, lengthToCover) => {
    if (lengthToCover <= 0)
        return [];
    return mountingRailProducts.reduce((finishedRailArrays, currentRail) => {
        const subsequentRailArrays = findArraysOfMountingRailsCoveringLength(mountingRailProducts, lengthToCover - getLengthOfMountingRail(currentRail));
        const newRailArrays = subsequentRailArrays.length
            ? [
                ...subsequentRailArrays.map((subsequentRailArray) => [
                    currentRail,
                    ...subsequentRailArray,
                ]),
            ]
            : [[currentRail]];
        return [...finishedRailArrays, ...newRailArrays];
    }, []);
};
export const calculateOptimalMountingRails = (availableMountingRails, lengthToCover, color) => {
    const availableRailsOfDesiredColor = availableMountingRails.filter((rail) => color ? getColorOfProduct(rail) === color : true);
    const railArrays = findArraysOfMountingRailsCoveringLength(availableRailsOfDesiredColor, lengthToCover);
    const smallestRailArrays = getSmallestArrays(railArrays);
    const cheapestOnesOfSmallestRailArrays = findCheapestProductArrays(smallestRailArrays);
    const chosenArray = cheapestOnesOfSmallestRailArrays[0];
    return chosenArray;
};
/**
 * Takes a boaxel solution and finds the most optimal combination of mounting rails for it. Filters first by size,
 * favoring the smallest array of mounting rail, thus getting the solutions with the largest possible mounting rail
 * combinations. Rest is filtered by price, favoring the cheapest combination possible.
 *
 * @param products
 * @param mountingRailEntitiesInSolution
 */
export const calculateOptimalMountingRailSetupForSolution = (products, mountingRailEntitiesInSolution) => {
    const widthOfSolution = getWidthOfSolution(mountingRailEntitiesInSolution);
    const uprightEntitiesInSolution = getUprightsInSolution(mountingRailEntitiesInSolution);
    if (uprightEntitiesInSolution.length <= 1)
        return [];
    const uprightProductsInSolution = uprightEntitiesInSolution.map((uprightEntity) => getEntityProductData(products, uprightEntity));
    const majorityColorOfUprights = getMajorityColorOfProducts(uprightProductsInSolution);
    const availableMountingRails = getMountingRailsProducts(products);
    const optimalMountingRails = calculateOptimalMountingRails(availableMountingRails, widthOfSolution, majorityColorOfUprights);
    const optimalMountingRailIds = optimalMountingRails.map(getProductRefFromProduct);
    return optimalMountingRailIds;
};
/**
 * Collect all boaxel solutions in a scene and finds the most optimal combination of mounting rails for each
 * one.
 *
 * @param core
 * @param products
 */
export const calculateOptimalMountingRailSetupForAllSolutions = (core, products) => {
    const solutionsInScene = getBoaxelSolutions(core);
    return solutionsInScene.map((solution) => calculateOptimalMountingRailSetupForSolution(products, solution));
};
